import { useEffect, useLayoutEffect, useRef, useState } from "react";

type NavKey = "payment" | "payService" | "settle" | "merchant" | "sales";

type Props = {
  selected: number;
  setSelected: (n: number) => void;
  topOffset?: number;
  onSelect: (key: NavKey) => void;
};

const NAV_ITEMS: {
  key: NavKey;
  label: string;
  icon: string;
  index: number;
}[] = [
  {
    key: "payment",
    label: "결제/정산 내역",
    icon: "/assets/images/icon/sidenav_list",
    index: 0,
  },
  {
    key: "settle",
    label: "정산 서비스",
    icon: "/assets/images/icon/sidenav_settle",
    index: 1,
  },
  {
    key: "merchant",
    label: "가맹점 서비스",
    icon: "/assets/images/icon/sidenav_merchant",
    index: 2,
  },
  {
    key: "payService",
    label: "결제 서비스",
    icon: "/assets/images/icon/sidenav_payment",
    index: 3,
  },
  {
    key: "sales",
    label: "영업대행 관리 서비스",
    icon: "/assets/images/icon/sidenav_sale",
    index: 4,
  },
];

export const SideNav = ({ selected, setSelected, topOffset = 80, onSelect }: Props) => {
  const containerRef = useRef<HTMLDivElement | null>(null); //  멈춤 기준 컨테이너
  const navRef = useRef<HTMLElement | null>(null);

  const [mode, setMode] = useState<"sticky" | "absolute">("sticky");
  const [navH, setNavH] = useState(0);

  const measure = () => {
    if (!navRef.current) return;
    setNavH(navRef.current.offsetHeight);
  };

  useLayoutEffect(() => {
    measure();
    const id = requestAnimationFrame(measure);
    return () => cancelAnimationFrame(id);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  // useEffect(() => {
  //   const onScroll = () => {
  //     if (!containerRef.current || !navRef.current) return;

  //     const containerRect = containerRef.current.getBoundingClientRect();
  //     const containerBottom = containerRect.bottom; // viewport 기준
  //     const navBottomIfSticky = topOffset + navH; // viewport 기준(붙어있을 때)

  //     //  sticky로 두면 nav bottom이 컨테이너 bottom을 넘어가려는 순간
  //     const shouldPinToBottom = navBottomIfSticky >= containerBottom;

  //     setMode(shouldPinToBottom ? "absolute" : "sticky");
  //   };

  //   onScroll();
  //   window.addEventListener("scroll", onScroll, { passive: true });
  //   return () => window.removeEventListener("scroll", onScroll);
  // }, [topOffset, navH]);

  return (
    //  이 컨테이너가 “SideNav가 따라다니다 멈춰야 하는 영역”이 됩니다.
    //    (보통 본문 섹션 높이만큼 잡히는 컬럼 wrapper)
    <div ref={containerRef} className="relative flex flex-col w-full max-w-[300px]">
      <aside
        ref={navRef}
        className="flex flex-col gap-5"
        style={
          mode === "sticky"
            ? { position: "sticky", top: topOffset, zIndex: 50 }
            : { position: "absolute", bottom: 0, zIndex: 50 } //  컨테이너 bottom에 박음
        }
      >
        {NAV_ITEMS.map((item) => {
          const isActive = selected === item.index;

          return (
            <nav
              key={item.key}
              className="flex flex-row gap-2 items-center cursor-pointer py-6"
              onClick={() => {
                setSelected(item.index);
                onSelect(item.key);
              }}
            >
              <img
                src={`${item.icon}${isActive ? "_selected" : ""}.png`}
                width={48}
                height={48}
                alt={item.label}
              />

              <span
                className={`text-heading1_2  font-bold transition-colors ${
                  isActive ? "text-[#0079FF]" : "text-[#121319]"
                }`}
              >
                {item.label}
              </span>
            </nav>
          );
        })}
      </aside>
    </div>
  );
};
